import { render, staticRenderFns } from "./CustomInputFile.vue?vue&type=template&id=0db57b90"
import script from "./CustomInputFile.vue?vue&type=script&lang=js"
export * from "./CustomInputFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports